import {
    getPositionFromAllPointsSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/position/helpers/getPositionFromAllPoints";
import {useState} from "react";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {OnRebuildPointsAndPositionMutateSingleVoyage} from "@containers/singleVoyage/mutateVoyage/points/types/events";

export function useRebuildPointsAndPositionsMutateSingleVoyage(): {
    onRebuild: OnRebuildPointsAndPositionMutateSingleVoyage,
    isPending: boolean
} {
    const [isPending, setIsPending] = useState(false)

    const {
        setPoints,
        setPositions,
    } = useRootContextMutateSingleVoyage()

    const onRebuild: OnRebuildPointsAndPositionMutateSingleVoyage = async ({
                                                                               points,
                                                                               onSuccess,
                                                                           }) => {

        if (points?.length < 2) {
            setPoints(points)
            setPositions([])
        }
        try {
            setIsPending(true)
            const {positions} = await getPositionFromAllPointsSingleVoyage({
                points: points
            })
            setPoints(points)
            setPositions(positions)
            setIsPending(false)
            onSuccess && onSuccess()
        } catch (error) {
            setIsPending(false)
        }
    }

    return {
        isPending,
        onRebuild
    }
}